import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/devops-enablement/banner_devops.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner devops_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={6} xl={7} xxl={8} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner">
                Super-Efficient DevOps Enablement
              </h1>
              <span>Transform Business with Streamlined DevOps Enablement</span>
              <p>
                Empower your teams with a cutting-edge framework for DevOps
                Enablement that ensures high-quality software development while
                accommodating your ever-evolving business needs.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Discover Now
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
